// extracted by mini-css-extract-plugin
export default {"ui":"Breadcrumbs_ui__BzW2Z","breadcrumbs":"Breadcrumbs_breadcrumbs__5yl2G"};